import axios from "axios";

export const ADD_REQUEST_KNOWLEDGE = "ADD_REQUEST_KNOWLEDGE";
export const GET_REQUEST_KNOWLEDGE = "GET_REQUEST_KNOWLEDGE";
export const EDIT_REQUEST_KNOWLEDGE = "EDIT_REQUEST_KNOWLEDGE";
export const EDIT_REQUEST_STATUS = "EDIT_REQUEST_STATUS";

const API = `${process.env.REACT_APP_API_URL}/api/knowledge/requestKnowledge`;

export const addRequestKnowledge = (data) => async (dispatch) => {
  const res = await axios.post(API, data, { withCredentials: true });
  dispatch({ type: ADD_REQUEST_KNOWLEDGE, payload: res.data.request });
  return res.data.request;
};

export const getRequestKnowledge = () => async (dispatch) => {
  try {
    const res = await axios.get(`${API}/allRequest`, {
      withCredentials: true,
    });
    dispatch({ type: GET_REQUEST_KNOWLEDGE, payload: res.data });
  } catch (error) {
    console.error(error);
  }
};

// Assignation d'un référent. Lève l'erreur pour que l'appelant gère succès/échec.
export const editRequestKnowledge =
  (knowledgeId, requestStatus, referentId) => async (dispatch) => {
    const res = await axios.put(
      `${API}/${knowledgeId}`,
      { requestStatus, referentId },
      { withCredentials: true }
    );
    dispatch({ type: EDIT_REQUEST_KNOWLEDGE, payload: res.data.request });
    return res.data.request;
  };

// Changement de statut. Lève l'erreur pour que l'appelant gère succès/échec.
export const editRequestStatus =
  (knowledgeId, requestStatus) => async (dispatch) => {
    const res = await axios.patch(
      `${API}/${knowledgeId}`,
      { requestStatus },
      { withCredentials: true }
    );
    dispatch({ type: EDIT_REQUEST_STATUS, payload: res.data.request });
    return res.data.request;
  };
